import * as React from 'react';
import type { SVGProps } from 'react';
/**
 * @internal
 */
const ArrowRightIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M13.8333 32.1667V8.83333L32.1667 20.5L13.8333 32.1667Z" fill="white" />
  </svg>
);
export default ArrowRightIcon;
